// extracted by mini-css-extract-plugin
module.exports = {"container":"amount_container__2YGI5","label":"amount_label__1YMV2","textContainer":"amount_textContainer__30N0c","text":"amount_text__QVFMS","icon":"amount_icon__2hXza"};